// extracted by mini-css-extract-plugin
module.exports = {"cancelContainer":"styles_cancelContainer__1iqFZ"};